import { FC, useCallback } from 'react'
import { BrgButton, ButtonVariant } from '@brg/ui'
import { useTranslation } from 'react-i18next'
import { useModal } from 'core'
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal'
import {
  CloseButton,
  ModalActions,
  ModalBody,
  ModalHeaderRow,
  ModalHollowButton,
  ModalTitle,
} from './styles'

type ChooseAkiStatusRefuseConfirmModalProps = {
  onConfirm?: () => void | Promise<void>
}

export const ChooseAkiStatusRefuseConfirmModal: FC<
  ChooseAkiStatusRefuseConfirmModalProps
> = ({ onConfirm }) => {
  const { t } = useTranslation()
  const modal = useModal()

  const handleClose = useCallback(() => {
    modal.hide()
  }, [modal])

  const handleConfirm = useCallback(() => {
    onConfirm?.()
  }, [onConfirm])

  return (
    <ModalBody>
      <ModalHeaderRow>
        <ModalTitle>{t('choose_aki_status.modal.refuse_confirm_title')}</ModalTitle>
        <CloseButton type="button" onClick={handleClose} aria-label={t('choose_aki_status.modal.close')}>
          <IconCloseMob />
        </CloseButton>
      </ModalHeaderRow>
      <ModalActions gx={16} direction="row" directionMobile="row" offsetTop={24}>
        <ModalHollowButton variant={ButtonVariant.Hollow} fullWidth onClick={handleConfirm}>
          {t('choose_aki_status.modal.refuse_confirm_yes')}
        </ModalHollowButton>
        <BrgButton variant={ButtonVariant.Filled} fullWidth onClick={handleClose}>
          {t('choose_aki_status.modal.refuse_confirm_cancel')}
        </BrgButton>
      </ModalActions>
    </ModalBody>
  )
}
import { FC, useCallback } from 'react'
import { BrgButton, ButtonVariant } from '@brg/ui'
import { useTranslation } from 'react-i18next'
import { useModal } from 'core'
import { IconCloseMob } from '../SelectGeoLocationTagsModal/SelectGeoLocationTagsModal'
import {
  CloseButton,
  ModalActions,
  ModalBody,
  ModalHeaderRow,
  ModalHollowButton,
  ModalTitle,
} from './styles'

type ChooseAkiStatusRefuseConfirmModalProps = {
  onConfirm?: () => void | Promise<void>
}

export const ChooseAkiStatusRefuseConfirmModal: FC<
  ChooseAkiStatusRefuseConfirmModalProps
> = ({ onConfirm }) => {
  const { t } = useTranslation()
  const modal = useModal()

  const handleClose = useCallback(() => {
    modal.hide()
  }, [modal])

  const handleConfirm = useCallback(() => {
    onConfirm?.()
  }, [onConfirm])

  return (
    <ModalBody>
      <ModalHeaderRow>
        <ModalTitle>{t('choose_aki_status.modal.refuse_confirm_title')}</ModalTitle>
        <CloseButton type="button" onClick={handleClose} aria-label={t('choose_aki_status.modal.close')}>
          <IconCloseMob />
        </CloseButton>
      </ModalHeaderRow>
      <ModalActions gx={16} direction="row" directionMobile="row" offsetTop={24}>
        <ModalHollowButton variant={ButtonVariant.Hollow} fullWidth onClick={handleConfirm}>
          {t('choose_aki_status.modal.refuse_confirm_yes')}
        </ModalHollowButton>
        <BrgButton variant={ButtonVariant.Filled} fullWidth onClick={handleClose}>
          {t('choose_aki_status.modal.refuse_confirm_cancel')}
        </BrgButton>
      </ModalActions>
    </ModalBody>
  )
}
